export default {"src":"/_next/static/media/carteira-de-trabalho.cd4692ff.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};